import React from 'react';
import { Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { formatMoneyPl } from '../../../utils/currency';
import type { CustomerOrderFreightRow } from '../customerOrderFreight';
import FreightOrderCard from './FreightOrderCard';

const { Text } = Typography;

interface CustomerOrderFreightCardsProps {
  /** Truck currency, PLN rate and total (usability round 2026-10-05). */
  truck?: { currency: string; rate: number | null; totalPLN: number | null } | null;
  rows: CustomerOrderFreightRow[];
  onOpenOrder: (orderId: string) => void;
}

/**
 * OUTBOUND truck: one card per customer order (ZK) with a share of the cost
 * (customerOrderFreight.ts), rendered with the shared `FreightOrderCard`.
 * Render only with `canViewTransportCosts`.
 */
const CustomerOrderFreightCards: React.FC<CustomerOrderFreightCardsProps> = ({ truck = null, rows, onOpenOrder }) => {
  const { t } = useTranslation(['transport']);
  return (
    <div className="transport-detail-card-list" data-testid="transport-customer-freight-list">
      {rows.map((row) => (
        <FreightOrderCard
          key={row.id}
          testIdPrefix="transport-customer-freight"
          label={row.label}
          partyName={row.customerName}
          onOpen={() => onOpenOrder(row.id)}
          tags={row.customerPickup ? (
            <Tag color="orange" className="transport-detail-zd-cost__tag" data-testid="transport-customer-freight-pickup">
              {t('transport:customerOrders.freight.pickupTag')}
            </Tag>
          ) : null}
          truck={truck}
          share={row.share}
          showShareAmount={rows.length > 1}
          lines={row.lines}
          totals={row.totals}
          showTable={row.totals !== null}
          missingText="—"
          emptyContent={(
            <>
              <Text strong>{formatMoneyPl(row.share.amountPLN, 'PLN')}</Text>
              <Text type="secondary">{t('transport:customerOrders.freight.noCargo')}</Text>
            </>
          )}
        />
      ))}
    </div>
  );
};

export default CustomerOrderFreightCards;
